import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import { Divider } from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main || '#6E759F',
    color: theme.palette.common.white,
    fontSize: '0.9rem',
    padding: '8px',
    textTransform: 'capitalize'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: '8px'
  }
}));

const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(odd)': {
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

export default function CustomTable({
  columns,
  rows,
  firstColumnLength = false,
  setSelectedRowData = undefined,
  pagination,
  isSearch
}) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  React.useEffect(() => {
    setPage(0);
  }, [isSearch, pagination]);

  return (
    <div style={{ width: '100%', overflowX: 'auto' }}>
      <TableContainer component={Paper} className='table_container_list'>
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              {columns?.map((heading, index) => {
                return (
                  <StyledTableCell
                    key={index}
                    align={heading !== 'Picture' ? 'center' : 'left'}
                  >
                    {heading}
                  </StyledTableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows?.length > 0 ? (
              rows
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow key={index}>
                    {Object.keys(row).map((key) => (
                      <React.Fragment key={key}>
                        {key !== 'id' && (
                          <StyledTableCell
                            sx={firstColumnLength ? { maxWidth: "30rem" } : {}}
                            onClick={() =>
                              setSelectedRowData && setSelectedRowData(row)
                            }
                            align="center"
                          >
                            {row[key]}
                          </StyledTableCell>
                        )}
                      </React.Fragment>
                    ))}
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <h4 style={{ textAlign: 'center' }}>No data found</h4>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
        <Divider sx={{ marginTop: 1 }} />
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={rows ? rows.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </div>
  );
}
